import Icon from '../components/Icon.vue'

Icon.register({"location-arrow":{"width":512,"height":512,"paths":[{"d":"M443.7 4.5L27.8 196.4C-18.7 217.9-3.4 288 47.9 288H224V464C224 515.7 294.2 530.5 315.6 484.1L507.4 68.2C526.3 27.3 483.6-13.9 443.7 4.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/location-arrow.js
// module id = null
// module chunks = 